import React from 'react'

const CreateProduct = () => {
  return (
    <div>
      hi
    </div>
  )
}

export default CreateProduct
